import React, { useEffect, useState } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import PoolsBySiteTable from "./PoolsBySiteTable";
import { useParams } from "react-router-dom";
import { fetchWithToken } from "../../../../apiUtils";

const useStyles = makeStyles({
  table: {
    marginTop: 45,
  },
  loading: {
    marginTop: "25%",
    marginLeft: "50%",
  },
});

const PoolsBySite = ({ isAdmin }) => {
  const classes = useStyles();

  const { siteId } = useParams();

  const [dataObj, setDataObj] = useState({
    pools: [],
    loading: true,
  });

  useEffect(() => {
    fetchWithToken(`api/Pools/BySite/${siteId}`)
      .then((response) => response.json())
      .then((data) =>
        setDataObj({
          pools: data,
          loading: false,
        })
      );
  }, []);

  return (
    <>
      {dataObj.loading ? (
        <CircularProgress className={classes.loading} />
      ) : (
        <div className={classes.table}>
          <PoolsBySiteTable
            data={dataObj.pools}
            title={"Pools"}
            isAdmin={isAdmin}
          />
        </div>
      )}
    </>
  );
};
export default PoolsBySite;
